module.exports = __webpack_public_path__ + "img/h-page4-50.815eba51.png";